namespace JupitersChoice {
    
    export class CheckBigWinCmd {

        @inject('BetModel') _betModel: Sapphire.BetModel;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('BigWinModel') _bigWinModel: BigWinModel;
        @inject('EventManager') _eventManager: Sapphire.EventManager;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            /*const superWinBackgroundEffect = this._componentManager.get('SuperWinBackgroundEffect');
            const superWinBackground = this._componentManager.get('SuperWinBackground');
            const superWinText = this._componentManager.get('SuperWinText');
            const superWinCounter = this._componentManager.get('SuperWinCounter');*/

            const winAmountFromCurrentSpin = this._responseHelper.getWinAmountFromCurrentSpin(response.winnings);
            const betAmount = this._betModel.getCurrentBet();

            if(this._stateModel.currentSubgame == 'FreeGame'){
                const currentFreeSpinInfo = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1];
                var fsSpinWinTotal: number = 0;
                for(var i=0; i<currentFreeSpinInfo.winnings.length;++i){
                    fsSpinWinTotal += currentFreeSpinInfo.winnings[i][2];
                }
                if(this._bigWinModel.check(fsSpinWinTotal, betAmount)){
                    this._bigWinModel.play(fsSpinWinTotal, betAmount);
                }else{
                    this._eventManager.publish('onHasNoFreeGameBigWin');
                }
            }else if(response.feature && this._stateModel.currentSubgame == 'BaseGame'){
                //return from feature total win
                if(this._bigWinModel.check(response.win, betAmount)){
                    this._bigWinModel.play(response.win, betAmount);
                } else {
                    this._eventManager.publish('onHasNoBigWin');
                }
            }else{
                if(this._bigWinModel.check(winAmountFromCurrentSpin, betAmount)){
                    this._bigWinModel.play(winAmountFromCurrentSpin, betAmount);
                }else{
                    //no big win, go away
                    if(winAmountFromCurrentSpin > 0){
                        this._eventManager.publish('startBaseGameWinAudio');
                    }
                    this._eventManager.publish('onHasNoBigWin');
                } 
            }
        }
    }
}
